var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 90,
    viewBox: "0 0 92 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.00454112L10.0573 17.8064C4.29792 25.3625 0.865043 34.7769 0.865043 45.0045C0.865043 69.8581 21.0525 90 45.9567 90C53.2367 90 60.107 88.2689 66.1942 85.211L59.3012 73.0023C55.2537 74.9288 50.7327 76.0102 45.9567 76.0102C28.8197 76.0102 14.8788 62.0976 14.8788 45C14.8788 40.2338 15.9669 35.7219 17.8973 31.6826L35.1436 62.2067H53.2003L18.0567 0H0V0.00454112Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2166 14.1625C64.8239 15.7936 77.0302 29.0019 77.0302 45.0045C77.0302 49.7117 75.9739 54.1736 74.0844 58.1765L49.2166 14.1625ZM45.7656 0.00454112C38.5994 0.0318028 31.8383 1.74021 25.8331 4.73445L73.9433 89.8819H92L81.9427 72.08C87.6474 64.5466 91.0439 55.1732 91.0439 45C91.0439 20.21 70.9612 0.104503 46.1435 0H45.7656V0.00454112Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.8fc05a33.svg";
export { ForwardRef as ReactComponent };